import axios from 'axios';
export default axios.create({ baseURL: 'https://server-your-price-booking.onrender.com/' });
